import {
  Logger
} from "./chunk-MG6YGXXR.mjs";

// src/react/sentry/index.ts
import * as Sentry from "@sentry/react";
var SentryReactLogger = class {
  constructor(opts) {
    Sentry.init(opts);
    Logger.init(this);
  }
  get isInitialized() {
    return !!Logger.isInitialized;
  }
  captureException(exception, context) {
    return Sentry.captureException(exception, context);
  }
  captureMessage(message, context) {
    return Sentry.captureMessage(message, context);
  }
  setUser(user) {
    return Sentry.setUser({
      ...user,
      id: user._id,
      username: user.name
    });
  }
  lastId() {
    return Sentry.lastEventId();
  }
  showReportDialog(opts) {
    Sentry.showReportDialog(opts);
  }
};

export {
  SentryReactLogger
};
//# sourceMappingURL=chunk-DP2AWBBO.mjs.map